// Sort copies only: request order and allocation payloads remain unchanged.
// Unknown totals follow verified values, including zero; ties retain their order.
export const sortByPoints = (rows, total) => [...rows].sort((a, b) => {
  const first = total(a), second = total(b)
  if (!Number.isFinite(first)) return Number.isFinite(second) ? 1 : 0
  if (!Number.isFinite(second)) return -1
  return second - first
})
